module.exports = __webpack_public_path__ + "media/assets/images/category/Graduation@2x-4e02ec9b28360379abf89ed6cfbdfc28.png";